<template>
    <br/>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="search" class="form-label mt-2 me-2">Keyword</label>
        <input type="text" id="search" class="form-control" placeholder="Name or creator" v-model="keyword"
               @input="searchKeyword"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="per-page" class="form-label me-1 mt-2">Status</label>
        <select id="per-page" class="form-control" v-model="status" @change="changeStatus(status)">
          <option value="" :value="status">All</option>
          <option value="paid" :value="status">Paid</option>
          <option value="pending" :value="status">Pending - Stripe</option>
          <option value="pending_confirmation" :value="status">Pending - Admin</option>
          <option value="canceled" :value="status">Canceled</option>
          <option value="failed" :value="status">Failed - Stripe</option>
          <option value="rejected" :value="status">Rejected - Admin</option>
        </select>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="per-page" class="form-label me-1 mt-2">Per page</label>
        <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="from-date" class="form-label mt-2 me-2">From date</label>
        <input type="datetime-local" id="from-date" class="form-control" placeholder="Name or creator" v-model="fromDate" @input="customDate"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="to-date" class="form-label mt-2 me-2">To date</label>
        <div class="d-flex gap-1">
          <input type="datetime-local" id="to-date" class="form-control" v-model="toDate" @input="customDate"/>
          <button type="button" class="btn btn-dark-purple" @click="searchDate">
            <font-awesome-icon :icon="['fas', 'magnifying-glass']"/>
          </button>
        </div>
      </div>
      <div class="table-responsive container-fluid">
        <table class="table">
          <thead>
          <tr>
            <th scope="col"># ID</th>
            <th scope="col">Date</th>
            <th scope="col">Status</th>
            <th scope="col">Full name, email</th>
            <th scope="col">Creator</th>
            <th scope="col">Amount</th>
            <th scope="col">Estimated arrival date</th>
            <th scope="col">Actions</th>
          </tr>
          </thead>
          <tbody>
            
          <tr v-if="loading">
            <td colspan="8" class="text-center"><font-awesome-icon icon="fa-solid fa-sync fa-10x" spin/></td>
          </tr>

          <tr v-else-if="payouts.length > 0" v-for="payout in payouts">
            <th scope="row">{{ payout.id }}</th>
            <td>{{ payout.created_at }}</td>
            <td style="text-transform: capitalize">{{ payout.status }}</td>
            <td>
              <p class="font-weight-bold">{{ payout.user.name }}</p>
              <a href="mailto:{{payout.user.email}}">{{ payout.user.email }}</a>
            </td>
            <td>
              <router-link v-if="payout.channel_id" :to="{name: 'SingleChannel',params: {id: payout.channel_id}}" target="_blank">
                {{payout.channel.name}}
              </router-link>
              <p v-else>-</p>
            </td>
            <td>
                <p>{{ payout.amount }} {{ payout.currency }}</p>
            </td>
            <td>{{ payout.estimated_arrival_date }}</td>
            <td v-if="payout.status == 'pending_confirmation'">
               <div class="btn-group-sm d-flex gap-3" role="group">
              <button :disabled="disableConfirmOrDeny" @click="confirmOrDenyPayout(payout.channel.name, payout.channel_id, payout.id, 1)" type="button" class="btn btn-success">
                  Confirm
              </button>

              <button :disabled="disableConfirmOrDeny" @click="confirmOrDenyPayout(payout.channel.name, payout.channel_id, payout.id, 0)" class="btn btn-danger">
                  Deny
              </button>
               </div>
            </td>
            <td v-else-if="payout.can_view_stripe_payout">
              <button
                type="button"
                class="btn btn-info"
                :disabled="viewingPayoutId === payout.id"
                @click="viewStripePayout(payout)"
              >
                {{ viewingPayoutId === payout.id ? 'Opening...' : 'View' }}
              </button>
            </td>
            <td v-else-if="payout.stripe_payout_error" class="text-danger">
              {{ payout.stripe_payout_error }}
            </td>
            <td v-else>-</td>
          </tr>
          <tr v-else>
            <td colspan="8" class="text-center">No payouts</td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
          <div>
            <div class="p-2">
              <p>Total payouts: {{ totalRecords }}</p>
            </div>
          </div>
          <div>
            <div class="p-2">
              <nav v-if="totalPages >= 1" aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                    <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
                  </li>
                  <li class="page-item" :class="{active: 1 === currentPage}">
                    <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
                  </li>
                  <li class="page-item" v-if="currentPage - 2 > 1">
                    <a href="#" class="page-link">...</a>
                  </li>
                  <li class="page-item" v-if="currentPage - 2 > 1">
                    <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2 }}</a>
                  </li>
                  <li class="page-item" v-if="currentPage - 1 > 1">
                    <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1 }}</a>
                  </li>
                  <li class="page-item" v-if="currentPage !== 1" :class="{active: currentPage}">
                    <a @click="paginate(currentPage)" class="page-link"
                       :class="{'not-clickable': currentPage}">{{ currentPage }}</a>
                  </li>
                  <li class="page-item" v-if="currentPage + 1 <= totalPages">
                    <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1 }}</a>
                  </li>
                  <li class="page-item" v-if="currentPage + 2 <= totalPages">
                    <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2 }}</a>
                  </li>
                  <li class="page-item" v-if="currentPage + 2 < totalPages">
                    <a href="#" class="page-link">...</a>
                  </li>
                  <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages"
                      :class="{active: totalPages === currentPage}">
                    <a @click="paginate(totalPages)" class="page-link"
                       :class="{'not-clickable': totalPages === currentPage}">{{ totalPages }}</a>
                  </li>
                  <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                    <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import axios from 'axios';
  import _debounce from "lodash/debounce";
  import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
  import Swal from "sweetalert2";
  
  export default {
    components: {FontAwesomeIcon},
    data() {
      return {
        loading: true,
        status: '',
        keyword: '',
        fromDate: '',
        toDate: '',
        name: '',
        payouts: [],
        validationErrors: [],
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        perPage: 20,
        disableConfirmOrDeny: false,
        viewingPayoutId: null,
        payoutModalTitle: '',
        payoutModalText: '',
        payoutModalIcon: '',
        
      }
    },
  
    mounted() {
        this.applyRouteQuery();
    },

    watch: {
      '$route.query'() {
        this.applyRouteQuery();
      }
    },

    methods: {
        applyRouteQuery() {
            this.status = this.$route.query.status ?? '';
            this.getPayouts(this.keyword, this.fromDate, this.toDate, this.status, this.currentPage, this.perPage);
        },
        debounceGetPayouts: _debounce(function (keyword, fromDate, toDate, status, page, perPage) {
            axios.get(`/admin/payouts?keyword=${keyword}&status=${status}&from_date=${fromDate}&to_date=${toDate}&page=${page}&per_page=${perPage}`).then(response => {
                console.log(response);
                this.payouts = response.data.data;
                this.totalPages = response.data.totalPages;
                this.totalRecords = response.data.totalRecords;
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.loading = false;
            });
        }, 500),
        getPayouts(keyword, fromDate, toDate, status, page, perPage) {
            this.loading = true;
            this.debounceGetPayouts(keyword, fromDate, toDate, status, page, perPage);
        },

        async viewStripePayout(payout) {
            const stripeTab = window.open('', '_blank');

            if (!stripeTab) {
                this.$toast.error('Please allow pop-ups to view this payout in Stripe.');
                return;
            }

            stripeTab.opener = null;
            this.viewingPayoutId = payout.id;

            try {
                const response = await axios.get(`/admin/payouts/${payout.id}/stripe-dashboard`);
                const stripeDashboardUrl = response.data?.url;

                if (!stripeDashboardUrl) {
                    throw new Error('Stripe Dashboard URL is missing.');
                }

                stripeTab.location.replace(stripeDashboardUrl);
            } catch (error) {
                stripeTab.close();
                this.$toast.error(
                  error.response?.data?.message || 'Unable to open this payout in Stripe.'
                );
            } finally {
                this.viewingPayoutId = null;
            }
        },

        async confirmOrDenyPayout(channelName, channelId, payoutId, confirmFlag){
            this.disableConfirmOrDeny = true;

            // Use a local config object instead of mutating component state
            const modalConfig = confirmFlag
              ? {
                  title: `Confirm payout`,
                  text: `Are you sure you want to CONFIRM this payout from ${channelName}?`,
                  icon: 'question'
                }
              : {
                  title: `Deny payout`,
                  text: `Are you sure you want to DENY this payout from ${channelName}?`,
                  icon: 'warning'
                };

            let confirmed = await Swal.fire({
              title: modalConfig.title,
              text: modalConfig.text,
              icon: modalConfig.icon,
              showCancelButton: true,
              confirmButtonText: 'Yes, proceed',
              cancelButtonText: 'Cancel'
            });

            if (confirmed.isConfirmed) {
              await axios.post(`/admin/confirm-or-reject-payout`, {
                channel_id: channelId,
                payout_id: payoutId,
                confirm: confirmFlag
              })
              .then(() => {
                this.disableConfirmOrDeny = false;

                this.$toast.success(
                  confirmFlag
                    ? 'Payout confirmed successfully!'
                    : 'Payout denied successfully!'
                );

                // Update local payout list
                const payout = this.payouts.find(p => p.id === payoutId);
                if (payout) {
                  payout.status = confirmFlag ? 'pending' : 'rejected';
                }
              })
              .catch((error) => {
                this.disableConfirmOrDeny = false;
                this.$toast.error('Failed to confirm/deny payout!');
              });
            } else {
              this.disableConfirmOrDeny = false;
            }
          },

        customDate(date) {
            let dateValue = this[date];

            // Check if the input is a valid date
            if (dateValue) {
                // Convert the input to a Date object
                const dateObject = new Date(dateValue);
                this[date] = this.formatDate(dateObject);
            }
        },
        searchDate() {
            this.getPayouts(this.keyword, this.fromDate, this.toDate, this.status, this.currentPage, this.perPage);
        },
        changeStatus(status) {
            this.status = status;
            this.getPayouts(this.keyword, this.fromDate, this.toDate,  this.status, this.currentPage, this.perPage);
        },
        searchKeyword() {
            this.getPayouts(this.keyword, this.fromDate, this.toDate,  this.status, this.currentPage, this.perPage);
        },
        perPageFilter(perPage) {
            this.perPage = perPage;
            this.getPayouts(this.keyword, this.fromDate, this.toDate,  this.status, this.currentPage, this.perPage);
        },
        paginate(page) {
            this.currentPage = page;
            this.getPayouts(this.keyword, this.fromDate, this.toDate,  this.status, this.currentPage, this.perPage);
        },
    }
  }
  </script>
